module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"putRecommendationSettingsButton.errorMessage":"There was an error encountered while updating this recommendation. If everything looks right please contact support so we can help you :)"}}')
  delete Component.options._Ctor
}
